@if (assessmentAndPlan) {
	<h4 class="section-title bg-default mrgn-btm">Today's Diagnoses</h4>
	<div class="margin-left-sm margin-bottom-lg">
		@for (diagnosis of assessmentAndPlan.personDiagnoses; track diagnosis) {
			<pms-rapid-review-diagnosis [diagnosis]="diagnosis"></pms-rapid-review-diagnosis>
		} @empty {
			No data to display
		}
	</div>
	<h4 class="section-title bg-default mrgn-btm">Performed Services</h4>
	<div class="margin-left-sm margin-bottom-lg">
		@for (service of assessmentAndPlan.formattedServices; track service) {
			<strong>{{ service.code }} -</strong> {{ service.description }}: {{ service.diagnosisCodes }}
		} @empty {
			No data to display
		}
	</div>
}
